export default [
  // {
  //   header: "Home",
  // },
  {
    title: "dashboard",
    route: "home",
    icon: "HomeIcon",
  },
  {
    title: "dentalNews",
    route: "news",
    icon: "InfoIcon",
    permission: ["backoffice-news.list", "backoffice-news.show-all"],
  },
  {
    title: "credits",
    icon: "ShoppingCartIcon",
    permission: [
      "backoffice-coupon-code.list",
      "backoffice-coupon-code.show-all"
    ],
    children: [
      {
        title: "couponCodes",
        route: "coupon-codes",
        permission: [
          "backoffice-coupon-code.list",
          "backoffice-coupon-code.show-all",
        ],
      },
      // {
      //   title: "creditsPackages",
      //   route: "packages",
      //   permission: "backoffice-package.list",
      // },
    ],
  },
  {
    title: "myCompany",
    icon: "InfoIcon",
    permission: [
      "backoffice-company.list",
      "backoffice-company.show-all",
      "backoffice-unit.list",
      "list-users",
      "backoffice-referral.list",
    ],
    children: [
      {
        title: "companyInformation",
        route: () => ({
          path: `/customers/${localStorage.getItem("company_id")}/edit`,
        }),
        permission: ["backoffice-company.list", "backoffice-company.show-all"],
      },
      {
        title: "users",
        route: "users",
        permission: "list-users",
      },

      {
        title: "referrals",
        route: "referral",
        permission: "backoffice-referral.list",
      },
      {
        title: "organizationalUnits",
        route: "unit",
        permission: "backoffice-unit.list",
      },
    ],
  },
  {
    title: "customers",
    route: "customers",
    icon: "UsersIcon",
    permission: ["backoffice-company.list", "backoffice-company.show-all"],
  },

  {
    title: "caseList",
    route: "my-cases",
    icon: "ListIcon",
    permission: [
      "backoffice-case-instance.list",
      "backoffice-case-instance.show-all",
    ],
  },
  {
    title: "paymentHistory",
    route: "payment-history",
    icon: "ClockIcon",
    permission: [
      "backoffice-payment-history.list",
      "backoffice-payment-history.show-all",
    ],
  },
  // {
  //   title: "paymentHistoryStripe",
  //   route: "payment-history-stripe",
  //   icon: "ClockIcon",
  //   permission: [
  //     "backoffice-stripe-invoice.show-all",
  //     "backoffice-stripe-invoice.list",
  //   ],
  // },
  {
    title: "invoices",
    route: "invoices",
    icon: "FileTextIcon",
    permission: ["backoffice-invoice.list", "backoffice-invoice.show-all"],
  },
  {
    title: "plans",
    route: "plans",
    icon: "CreditCardIcon",
    permission: "backoffice-plan.list",
  },
  {
    title: "globalConfiguration",
    route: "global-configuration",
    icon: "SettingsIcon",
    permission: "backoffice-global-configuration.save",
  },
  {
    title: "materialsConfiguration",
    route: "materials-configuration",
    icon: "SettingsIcon",
    permission: "backoffice-material.list",
  },
  {
    title: "registrationConfiguration",
    route: "registration-configuration",
    icon: "SettingsIcon",
    permission: "backoffice-global-configuration.save",
  },

  {
    title: "ticketSystem",
    route: "tickets",
    icon: "CheckSquareIcon",
    permission: ["backoffice-ticket.list", "backoffice-ticket.show-all"],
  },
];
